const PourCoffee = () => {
  return <li>Pour in the ground coffee.</li>;
};

export default PourCoffee;
